import { connect as formikConnect } from 'formik';
import HeightInputField from './HeightInputField';

export default formikConnect(HeightInputField);
